import React from 'react';
import './ScheduleSection.css';
import { motion } from 'framer-motion';

const ScheduleSection = () => {
  const schedules = [
    {
      title: "Practical Sessions",
      time: "3:00 PM - 4:30 PM",
      highlight: "200+ Live Codes",
      description: "Hands-on implementation of core concepts with real-time debugging.",
      icon: "💻"
    },
    {
      title: "Interactive Lectures",
      time: "5:00 PM - 8:00 PM",
      highlight: "In-depth Mastery",
      description: "Deep dive into Java fundamentals, architecture, and professional patterns.",
      icon: "📚"
    }
  ];

  return (
    <section className="ucp-section ucp-schedule">
      <div className="schedule-container">
        <motion.div 
          className="schedule-header"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <h2 className="schedule-title">Daily Schedule & Timings</h2>
          <p className="schedule-subtitle">Optimized learning window for maximum retention and practice.</p>
        </motion.div>

        <div className="schedule-grid">
          {schedules.map((item, index) => (
            <motion.div 
              key={index}
              className="schedule-card"
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.2 }}
            >
              <div className="card-icon">{item.icon}</div>
              <h3 className="card-title">{item.title}</h3>
              <div className="card-time-badge">{item.time}</div>
              <div className="card-highlight">{item.highlight}</div>
              <p className="card-desc">{item.description}</p>
              
              <div className="card-glow"></div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ScheduleSection;
